import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import avatarPlaceholder from '../../../assets/images/mock/default-profile-icon.png'
import SmallMilestoneIcon from '../../common/SmallMilestoneIcon'
import { GENDER_LABEL_KEYS } from '../../../utility/userHelper'

import { ReactComponent as TimeIcon } from '../../../assets/images/common/icons/time-icon.svg'
import { ReactComponent as FlagIcon } from '../../../assets/images/common/icons/simple-flag-icon.svg'

import styles from './PairingGroup.module.scss'
import { DATETIME_FORMAT, getMomentInCommunityTimezoneReversed } from '../../../utility/datesHelper'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const PairingGroup = ({ pairingGroup }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)

  return (
    <div className={classNames(styles.pairingGroup, 'd-flex  w-100 mx-auto')}>
      <div className='col-2 p-0'>
        <div className={classNames('pl-2 pr-2 d-flex justify-content-between align-items-center flex-wrap', styles.pairingGroupInfo)}>
          <span className={styles.pairingGroupOrder}>
            <FlagIcon className={styles.flagIcon}/>
            {pairingGroup.startHole.value || pairingGroup.playersGroup.value
              ? t('events.detail.pairingGroup.hole', { value: `${pairingGroup.startHole.value}${pairingGroup.playersGroup.value}` })
              : ''}
          </span>

          <span className={classNames('d-flex align-items-center', styles.pairingGroupTime)}><TimeIcon className={styles.timeIcon}/>
            {getMomentInCommunityTimezoneReversed(moment(pairingGroup.startTime), timezone, DATETIME_FORMAT).format('LT')}
          </span>
        </div>
      </div>
      <div className='col-10 d-flex w-100 flex-wrap'>
        {pairingGroup.users?.filter(Boolean).map((student, index) => (
          <button
            className={classNames('d-flex align-items-center px-2', styles.studentCard)}
            onClick={() => navigate(`/profile/${student.id}`)}
            key={index}
          >
            <div className='mr-3 smaller-round-image-wrapper' >
              <img
                alt={t('events.detail.pairingGroup.avatarAlt')}
                className='round-image'
                src={student.avatar?.fileUrl || avatarPlaceholder}
              />
            </div>
            <SmallMilestoneIcon fromAvatar className={styles.studentLevel} division={student.level} />
            <div className={styles.studentData}>
              <p className={styles.studentName}>{student.firstName} {student.lastName}</p>
              <p>{t('events.detail.pairingGroup.ageGender', { age: student.age, gender: t(GENDER_LABEL_KEYS[student.gender]) })}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

PairingGroup.propTypes = {
  pairingGroup: PropTypes.object.isRequired,
}

export default PairingGroup
